<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <!-- messageSenderInformation -->
        <div class="md:tw-w-1/3 2xl:tw-w-1/4">
          <fieldset class="tw-h-full" formGroupName="messageSenderInformation">
            <legend>
              {{ pageVocabs + "legends.messageSenderInformation" | translate }}
            </legend>

            <div class="row">
              <!-- smsSenderAgentId -->
              <div class="sm:tw-w-1/2 md:tw-w-full">
                <sms-sender-agent-chip-list-select-search
                  *ngIf="!formPageConfig.isEditMode"
                  [isShowSelectAll]="true"
                  [label]="fields + 'smsSenderAgentId'"
                  [control]="
                    form?.get('messageSenderInformation.smsSenderAgentId')
                  "
                  [value]="model.smsSenderAgentIds"
                  (valuesChange)="model.smsSenderAgentIds = $event"
                  (onError)="onClose()"
                >
                </sms-sender-agent-chip-list-select-search>
                <sms-sender-agent-select-search
                  *ngIf="formPageConfig.isEditMode"
                  [control]="
                    form?.get('messageSenderInformation.smsSenderAgentId')
                  "
                  [(value)]="model.smsSenderAgentId"
                  [label]="fields + 'smsSenderAgentId'"
                  (onError)="onClose()"
                >
                </sms-sender-agent-select-search>
              </div>

              <!-- useForm -->
              <div class="sm:tw-w-1/2 md:tw-w-full">
                <enum-select-search
                  class="tw-w-full"
                  enumName="PrivateNumberUseForm"
                  [label]="fields + 'useForm'"
                  [control]="form?.get('messageSenderInformation.useForm')"
                  [value]="model.useForm"
                  (valueChange)="changeUseFormValidations($event)"
                  (onError)="onClose()"
                  class="rtl:tw-ml-[-59px] ltr:tw-mr-[-59px] tw-right-0"
                >
                </enum-select-search>
              </div>

              <!-- number -->
              <div
                class="sm:tw-w-1/2 md:tw-w-full"
                [class]="
                  model?.useForm === PrivateNumberUseForm.OneNumber
                    ? ''
                    : 'd-none'
                "
              >
                <form-field
                  [(value)]="model.number"
                  [control]="form?.get('messageSenderInformation.number')"
                  label="common.number"
                  type="tel"
                >
                </form-field>
              </div>

              <!-- mask -->
              <div
                class="sm:tw-w-1/2 md:tw-w-full"
                [class]="
                  model?.useForm === PrivateNumberUseForm.Mask ? '' : 'd-none'
                "
              >
                <form-field
                  [(value)]="model.mask"
                  [control]="form?.get('messageSenderInformation.mask')"
                  [label]="fields + 'mask' | translate"
                >
                </form-field>
              </div>

              <!-- range -->
              <!-- TODO Guide form field -->
              <div
                class="sm:tw-w-1/2 md:tw-w-full"
                [class]="
                  model?.useForm === PrivateNumberUseForm.RangeNumber
                    ? ''
                    : 'd-none'
                "
              >
                <!-- [hasGuide]="true" -->
                <form-field
                  [(value)]="model.range"
                  [control]="form?.get('messageSenderInformation.range')"
                  [label]="fields + 'range' | translate"
                >
                  <!-- *guide -->
                  <div suffix-content>
                    <mat-icon
                      mat-icon-button
                      class="tw-cursor-pointer dark:tw-text-gray-400"
                      [popoverTitle]="'common.help' | translate"
                      [autoClose]="'outside'"
                      [ngbPopover]="guideContent"
                      matSuffix
                    >
                      help_outline
                    </mat-icon>
                    <ng-template #guideContent>
                      <div class="sm:tw-w-[400px] tw-w-[250px]">
                        <div class="tw-flex tw-justify-start">
                          <span>{{ "common.example" | translate }}</span>
                          <span dir="ltr" class="tw-mx-2">{{
                            this.singleRangeExample
                          }}</span>
                        </div>
                        <div class="row">
                          <div class="md:tw-w-1/3">
                            <ol>
                              <li>
                                {{
                                  "pages.infrastructure.privateNumbers.privateNumbersForm.oneOfTheNumbers1To9"
                                    | translate
                                }}
                              </li>
                              <li>
                                {{
                                  "pages.infrastructure.privateNumbers.privateNumbersForm.twoTo11Times0To9"
                                    | translate
                                }}
                              </li>
                              <li>
                                {{
                                  "pages.infrastructure.privateNumbers.privateNumbersForm.maximum9Times"
                                    | translate
                                }}
                              </li>
                            </ol>
                          </div>
                          <div class="md:tw-w-2/3">
                            <img
                              src="/assets/media/Helper/singleRangeNumber.png"
                              alt=""
                            />
                          </div>
                        </div>
                        <div class="tw-flex tw-justify-start">
                          <span>{{ "common.example" | translate }}</span>
                          <span dir="ltr" class="tw-mx-2">{{
                            this.multipleRangeExample
                          }}</span>
                        </div>
                        <div class="row">
                          <div class="md:tw-w-1/3">
                            <ol>
                              <li>
                                {{
                                  "pages.infrastructure.privateNumbers.privateNumbersForm.oneOfTheNumbers1To9"
                                    | translate
                                }}
                              </li>
                              <li>
                                {{
                                  "pages.infrastructure.privateNumbers.privateNumbersForm.threeTo11Times0To9"
                                    | translate
                                }}
                              </li>
                              <li>*</li>
                            </ol>
                          </div>
                          <div class="md:tw-w-2/3">
                            <img
                              src="/assets/media/Helper/multipleRangeNumber.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </form-field>
              </div>

              <!-- header -->
              <div class="sm:tw-w-1/2 md:tw-w-full">
                <form-textarea
                  class="tw-w-full"
                  label="common.header"
                  [(value)]="model.smsHeader"
                  [control]="form?.get('header')"
                  [rows]="2"
                >
                </form-textarea>
              </div>

              <!-- signature -->
              <div class="sm:tw-w-1/2 md:tw-w-full">
                <form-textarea
                  class="tw-w-full"
                  label="common.signature"
                  [(value)]="model.signature"
                  [control]="form?.get('signature')"
                  [rows]="2"
                >
                </form-textarea>
              </div>
            </div>
          </fieldset>
        </div>
        <!-- generalSettings -->
        <div class="md:tw-w-2/3 2xl:tw-w-3/4 md:tw-mt-0 sm:tw-mt-3">
          <fieldset class="tw-h-full" formGroupName="generalSettings">
            <legend>
              {{ pageVocabs + "legends.generalSettings" | translate }}
            </legend>

            <div class="row">
              <!-- type -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <enum-select-search
                  class="tw-w-full"
                  enumName="TypePrivateNumberAccesses"
                  label="common.type"
                  [control]="form?.get('generalSettings.type')"
                  [(value)]="model.type"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- priority -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <enum-select-search
                  class="tw-w-full"
                  enumName="SendPriority"
                  [label]="fields + 'priority'"
                  [control]="form?.get('generalSettings.priority')"
                  [(value)]="model.priority"
                  (onError)="onClose()"
                >
                </enum-select-search>
              </div>

              <!-- price -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <form-field
                  type="tel"
                  [hasNumberSeparator]="true"
                  [(value)]="model.price"
                  [hasCurrency]="true"
                  [isLtr]="true"
                  [control]="form?.get('generalSettings.price')"
                  [label]="'common.price'"
                >
                </form-field>
              </div>

              <!-- tryCount -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <custom-select-search
                  [label]="fields + 'tryCount'"
                  [items]="
                    $any([
                      { value: 0 },
                      { value: 5 },
                      { value: 10 },
                      { value: 15 }
                    ])
                  "
                  optionTitle="value"
                  optionValue="value"
                  [removable]="false"
                  [value]="model.tryCount || 5"
                  (valueChange)="model.tryCount = $event"
                >
                </custom-select-search>
              </div>

              <!-- expireDate -->
              <div class="xl:tw-w-2/3">
                <app-date-time-picker
                  [config]="dateTimeConfig"
                  (dateTime)="model.expireDate = $event"
                >
                </app-date-time-picker>
              </div>

              <!-- refundDeliveryStatusId-->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <refund-delivery-statuses-select-search
                  class="tw-w-full"
                  [label]="fields + 'refundDeliveryStatusId'"
                  [control]="
                    form?.get('generalSettings.refundDeliveryStatusId')
                  "
                  [(value)]="model.refundDeliveryStatusId"
                  (onError)="onClose()"
                >
                </refund-delivery-statuses-select-search>
              </div>

              <!-- tag -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3">
                <form-field
                  [(value)]="model.tag"
                  [control]="form?.get('generalSettings.tag')"
                  [label]="fields + 'tag'"
                >
                </form-field>
              </div>

              <!-- descriptions -->
              <div class="xl:tw-w-2/3">
                <form-textarea
                  label="common.description"
                  [(value)]="model.description"
                  [control]="form?.get('description')"
                  [maxLength]="100"
                  [rows]="2"
                >
                </form-textarea>
              </div>
            </div>

            <div class="row tw-mt-[20px]">
              <!-- isActive -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.isActive" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- sendToBlackList -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="sendToBlackList"
                  [(ngModel)]="model.sendToBlackList"
                >
                  {{ fields + "sendToBlackList" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isGeneralBlackList -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isGeneralBlackList"
                  [(ngModel)]="model.isGeneralBlackList"
                >
                  {{ fields + "isGeneralBlackList" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- checkFilter -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="checkFilter"
                  [(ngModel)]="model.checkFilter"
                >
                  {{ fields + "checkFilter" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isSendDevice -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendDevice"
                  [(ngModel)]="model.isSendDevice"
                >
                  {{ fields + "isSendDevice" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isAutomaticBulk -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isAutomaticBulk"
                  [(ngModel)]="model.isAutomaticBulk"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{ fields + "isAutomaticBulk" | translate }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{ fields + "isAutomaticBulk" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isAutomaticGroup -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isAutomaticGroup"
                  [(ngModel)]="model.isAutomaticGroup"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{ fields + "isAutomaticGroup" | translate }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{ fields + "isAutomaticGroup" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isSendSmart -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendSmart"
                  [(ngModel)]="model.isSendSmart"
                >
                  {{ fields + "isSendSmart" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isAutomaticDynamicAndP2P -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="confirmP2pAndDynamic"
                  [(ngModel)]="model.isAutomaticDynamicAndP2P"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{ fields + "confirmP2pAndDynamic" | translate }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{ fields + "confirmP2pAndDynamic" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- IsNeedToSendConfirmationMessage  -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isNeedToSendConfirmationMessage"
                  [(ngModel)]="model.isNeedToSendConfirmationMessage"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{
                        fields + "isNeedToSendConfirmationMessage" | translate
                      }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{
                        fields + "isNeedToSendConfirmationMessage" | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- IsSendPrivateNumberExpirationMessage  -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendPrivateNumberExpirationMessage"
                  [(ngModel)]="model.isSendPrivateNumberExpirationMessage"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{
                        fields + "isSendPrivateNumberExpirationMessage"
                          | translate
                      }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{
                        fields + "isSendPrivateNumberExpirationMessage"
                          | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isCanSendFlashSms  -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isCanSendFlashSms"
                  [(ngModel)]="model.isCanSendFlashSms"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{ fields + "isCanSendFlashSms" | translate }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{ fields + "isCanSendFlashSms" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>

              <!-- isCanSendSmartWithoutConfirmation  -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isCanSendSmartWithoutConfirmation"
                  [(ngModel)]="model.isCanSendSmartWithoutConfirmation"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{
                        fields + "isCanSendSmartWithoutConfirmation" | translate
                      }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{
                        fields + "isCanSendSmartWithoutConfirmation" | translate
                      }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>
              <!-- isSendOccasionPhonebook  -->
              <div class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
                <mat-slide-toggle
                  formControlName="isSendOccasionPhonebook"
                  [(ngModel)]="model.isSendOccasionPhonebook"
                >
                  <app-expand-text [placement]="'right'">
                    <span small-text>
                      {{ fields + "isSendOccasionPhonebook" | translate }}
                    </span>
                    <div full-text class="full-text-display tw-w-[250px]">
                      {{ fields + "isSendOccasionPhonebook" | translate }}
                    </div>
                  </app-expand-text>
                </mat-slide-toggle>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="md:tw-w-1/3 !tw-mt-3">
          <fieldset style="height: 20rem" formGroupName="generalSettings">
            <legend>
              {{ pageVocabs + "legends.bulkSend" | translate }}
            </legend>

            <div class="row tw-space-y-2">
              <!-- select all -->
              <div class="tw-mb-5 border-bottom">
                <mat-slide-toggle
                  [ngModelOptions]="{ standalone: true }"
                  (change)="changeSelectAllByType($event, '.bulkSend', true)"
                  [(ngModel)]="isSelectBulkSend"
                  class="tw-mb-4"
                >
                  {{ "common.selectAll" | translate }}
                </mat-slide-toggle>
              </div>
              <!-- isSendBulk -->
              <div>
                <mat-slide-toggle
                  class="bulkSend"
                  (change)="changeSelectAllByType($event, '.bulkSend', false)"
                  formControlName="isSendBulk"
                  [(ngModel)]="model.isSendBulk"
                >
                  {{ fields + "isSendBulk" | translate }}
                </mat-slide-toggle>
              </div>
              <!-- isSendBulk2 -->
              <div>
                <mat-slide-toggle
                  class="bulkSend"
                  (change)="changeSelectAllByType($event, '.bulkSend', false)"
                  formControlName="isSendBulk2"
                  [(ngModel)]="model.isSendBulk2"
                >
                  {{ fields + "isSendBulk2" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </fieldset>
        </div>
        <div class="md:tw-w-1/3 !tw-mt-3">
          <fieldset style="height: 20rem" formGroupName="generalSettings">
            <legend>
              {{ pageVocabs + "legends.webServiceSend" | translate }}
            </legend>

            <div class="row tw-space-y-2">
              <!-- select all -->
              <div class="tw-mb-5 border-bottom">
                <mat-slide-toggle
                  [ngModelOptions]="{ standalone: true }"
                  class="tw-mb-4"
                  (change)="
                    changeSelectAllByType($event, '.webServiceSend', true)
                  "
                  [(ngModel)]="isSelectWebServiceSend"
                >
                  {{ "common.selectAll" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isSendOtp -->
              <div>
                <mat-slide-toggle
                  class="webServiceSend"
                  (change)="
                    changeSelectAllByType($event, '.webServiceSend', false)
                  "
                  formControlName="isSendOtp"
                  [(ngModel)]="model.isSendOtp"
                >
                  {{ fields + "isSendOtp" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendApiP2P -->
              <div>
                <mat-slide-toggle
                  class="webServiceSend"
                  (change)="
                    changeSelectAllByType($event, '.webServiceSend', false)
                  "
                  formControlName="isSendApiP2P"
                  [(ngModel)]="model.isSendApiP2P"
                >
                  {{ fields + "isSendApiP2P" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendApiSingle -->
              <div>
                <mat-slide-toggle
                  class="webServiceSend"
                  (change)="
                    changeSelectAllByType($event, '.webServiceSend', false)
                  "
                  formControlName="isSendApiSingle"
                  [(ngModel)]="model.isSendApiSingle"
                >
                  {{ fields + "isSendApiSingle" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </fieldset>
        </div>
        <div class="md:tw-w-1/3 !tw-mt-3">
          <fieldset style="height: 20rem" formGroupName="generalSettings">
            <legend>
              {{ pageVocabs + "legends.toNumberSend" | translate }}
            </legend>

            <div class="row tw-space-y-2">
              <!-- select all -->
              <div class="tw-mb-5 border-bottom">
                <mat-slide-toggle
                  [ngModelOptions]="{ standalone: true }"
                  class="tw-mb-4"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', true)
                  "
                  [(ngModel)]="isSelectToNumberSend"
                >
                  {{ "common.selectAll" | translate }}
                </mat-slide-toggle>
              </div>

              <!-- isSendSingle -->
              <div>
                <mat-slide-toggle
                  class="toNumberSend"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', false)
                  "
                  formControlName="isSendSingle"
                  [(ngModel)]="model.isSendSingle"
                >
                  {{ fields + "isSendSingle" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendPhonebook -->
              <div>
                <mat-slide-toggle
                  class="toNumberSend"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', false)
                  "
                  formControlName="isSendPhonebook"
                  [(ngModel)]="model.isSendPhonebook"
                >
                  {{ fields + "isSendPhonebook" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendClub -->
              <div>
                <mat-slide-toggle
                  class="toNumberSend"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', false)
                  "
                  formControlName="isSendClub"
                  [(ngModel)]="model.isSendClub"
                >
                  {{ fields + "isSendClub" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendDynamic -->
              <div>
                <mat-slide-toggle
                  class="toNumberSend"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', false)
                  "
                  formControlName="isSendDynamic"
                  [(ngModel)]="model.isSendDynamic"
                >
                  {{ fields + "isSendDynamic" | translate }}</mat-slide-toggle
                >
              </div>

              <!-- isSendP2P -->
              <div>
                <mat-slide-toggle
                  class="toNumberSend"
                  (change)="
                    changeSelectAllByType($event, '.toNumberSend', false)
                  "
                  formControlName="isSendP2P"
                  [(ngModel)]="model.isSendP2P"
                >
                  {{ fields + "isSendP2P" | translate }}</mat-slide-toggle
                >
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
  
</app-page-body>
